import { useEntitySearch } from '@/common/presentation/hooks/useEntitySearch';

export const useEmployeeSearch = () => {
  return useEntitySearch();
};
